<template>
  <vs-popup
    class="Change_petition_wrap documents_modal_popup"
    :title="popTitle"
    :active.sync="showPopup"
    v-if="showPopup"
  >
    <div class="Change_petition">
      <div class="vx-col w-full">
        <fileUploadNote :fileNote="true" />
        <!---
         fileModel:[],
        uploadScanedFilsList:[],
         --->
         <div @click="paralegalformerrors = ''" class="vx-row form-container pad0" v-if="ACTIVITYCODE !='UPLOAD_BENEFICIARY_SCANNED_COPY' && [50,51].indexOf(getUserRoleId)<=-1 && !checkSignerLogin && ACTIVITYCODE !='RFE_RESPONSE_UPLOAD_DOCS'">
              <div class="custom-radio_wrap wf_radio">
                
                <ul class="custom-radio mb-1" v-if="showOptions">
                  <li>
                    <vs-radio  v-if="checkH4Required || [2,10].indexOf(checkProperty(petitionDetails, 'type' ))>-1"  name="workflowType" @input="updateDocUserType" vs-value="Beneficiary" v-model="docUserType" class="w-full"
                      >Beneficiary</vs-radio> 
                  </li>
                  <li v-if="([2,10].indexOf(checkProperty(petitionDetails, 'type' ))>-1 && checkProperty(petitionDetails, 'petitionerId') ) ||  [2,10].indexOf(checkProperty(petitionDetails, 'type' ))<=-1 ">
                      <vs-radio    name="workflowType"  @input="updateDocUserType" vs-value="Petitioner"   v-model="docUserType" class="w-full"
                      >
                      <template v-if="[4].indexOf(checkProperty(petitionDetails, 'type' ))>-1 && [18,19].indexOf(checkProperty(petitionDetails, 'subTypeDetails', 'id' ))>-1">Sponsor</template>
                      <template v-else-if="getTenantTypeId == 2 && ([5, 1, 3].indexOf(checkProperty(petitionDetails, 'type')) > -1) && (checkProperty(petitionDetails, 'type') !== 3 || [16, 17].indexOf(checkProperty(petitionDetails, 'subTypeDetails', 'id')) > -1)">Authorized Signer</template>
                      <template v-else>Petitioner</template>
                    </vs-radio> 
                  </li>
                  <li>
                      <vs-radio    name="workflowType"  @input="updateDocUserType" vs-value="Internal"   v-model="docUserType" class="w-full">
                        <template v-if="getTenantTypeId == 2">Corporate</template>
                        <template v-else>Law Firm</template>
                    </vs-radio> 
                  </li>
                </ul>
              </div>
        </div>
       
        <div class="vx-row mt-3">
          <div class="vx-col w-full" @click="paralegalformerrors = ''">
            <vx-input-group class="form-input-group select-upload-group">
              <div class="uploadsec_wrap">
                <div class="w-full" @click="fileModel = []">
                  <div class="relative">
                    <file-upload
                      v-model="fileModel"
                      class="file-upload-input mb-0"
                      style="height: 50px"
                      :name="'pdocumentUpload'"
                      :multiple="true"
                      :hideSelected="true"
                      @updateData="updateData"
                      label="Forms and Letters"
                      :fieldName="'pdocumentUpload'"  :cid="'pdocumentUpload'"
                      :accept="pdfDocEntity"
                     
                    >
                    <!-- accept="application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                       @input="upload(fileModel)" --> 
                      <img
                        class="file-icon"
                        src="@/assets/images/main/file-upload.svg"
                      />
                      Upload
                    </file-upload>
                    <!-- <span class="loader" v-if="filesAreuploading"
                      ><img src="@/assets/images/main/loader.gif"
                    /></span> -->
                  </div>
                 
                  <span class="file-type mb-0"
                    >(File Type: PDF, DOC, Max file size: 200MB)</span
                  >
                  <input  type="hidden" data-vv-as="Documents"  v-validate="'required|docsValidate'" v-model="uploadScanedFilsList" name="pdocuments" >
              
                  <span class="text-danger text-sm"   v-show="errors.has('pdocuments')">Documents are required</span>
                  <VuePerfectScrollbar class="scrollbardoc">
                    <div
                      class="uploded-files_wrap mt-5 upload_tags"
                      v-if="
                        uploadScanedFilsList && uploadScanedFilsList.length > 0
                      "
                    >
                      <div
                        class="w-full"
                        v-for="(fil, fileindex) in uploadScanedFilsList"
                        :key="fileindex"
                      >
                        <div class="uploded-files">
                          <vx-input-group class="form-input-group">
                            <vs-input
                              v-on:keyup="
                                fileNameChengedScannedFiles(fileindex)
                              "
                              v-validate="'required'"
                              required
                              class="w-full"
                              :name="'fName' + fileindex"
                              v-model="uploadScanedFilsList[fileindex]['name']"
                              data-vv-as="File Name"
                            />

                            <span
                              class="text-danger text-sm"
                              v-if="errors.has('fName' + fileindex)"
                              >{{ errors.first("fName" + fileindex) }}</span
                            >
                            <span
                              class="text-danger text-sm"
                              v-else-if="
                                !uploadScanedFilsList[fileindex]['name']
                              "
                              >* File Name is required</span
                            >

                            <div
                              class="delete"
                              style="z-index: 999"
                              @click="remove(fileindex, uploadScanedFilsList)"
                            >
                              <img src="@/assets/images/main/cross.svg" /> 
                            </div>
                          </vx-input-group>
                          <div class="custom-radio_wrap wf_radio v2" :id="fil['path']+fileindex" v-if="docUserType !='Beneficiary' && [51].indexOf(getUserRoleId)<=-1 &&  [1].indexOf(checkProperty(petitionDetails, 'typeDetails', 'id'))>-1">
                            <ul class="custom-radio mb-1" :id="fil['path']+fileindex">
                                <li v-for="(option, index) in radioOptions" :key="index">
                                  <template v-if="checkProperty(option, 'value') != 'lca' || (checkProperty(option, 'value') == 'lca' && checkLcarequired )">
                                    <vs-radio 
                                        :id="'radio_' + fileindex+index" 
                                        :vs-name="'docType_'+fileindex"  
                                        :vs-value="option.value" 
                                        v-model="uploadScanedFilsList[fileindex].category" 
                                        class="w-full"
                                        @change="updateTagVal(uploadScanedFilsList[fileindex].category, fileindex)"
                                    >
                                        {{ option.label }}
                                    </vs-radio>
                                  </template>
                                </li>
                                <input type="hidden" :key="'docType_'+fileindex" :name="'docType_'+fileindex" v-validate="'required'" v-model="uploadScanedFilsList[fileindex].category">
                                <span class="text-danger text-sm" v-show="errors.has('docType_'+fileindex)">*Field is required</span>
                            </ul>
                          </div>
                        </div>
                        
                      </div>
                  
                    </div>
                  </VuePerfectScrollbar>
                </div>
              </div>
            </vx-input-group>
          </div>
        </div>

        

      </div>

      <div
        class="text-danger text-sm formerrors"
        v-if="paralegalformerrors != ''"
      >
        <vs-alert
          color="warning"
          class="warning-alert reg-warning-alert no-border-radius"
          icon-pack="IntakePortal"
          icon="IP-information-button"
          active="true"
          >{{ paralegalformerrors }}</vs-alert
        >
      </div>
    </div>
    <div class="popup-footer relative">
   
      <button
        @click="hideMe()"
        class="btn cancel"
      >
        Cancel
      </button>
      <button
        class="btn save"
        v-bind:disabled="
        
          filesAreuploading 
        "
        @click="submitForm()"
      >
      <figure v-if="filesAreuploading" class="loader"><img src="@/assets/images/main/loader.gif" /></figure>
        Submit
      </button>
    </div>
  </vs-popup>
</template>
<script>
import FileUpload from "@/views/FileUpload.vue";
import moment from "moment";
//import FileUpload from "vue-upload-component/src";
import docType from "@/views/common/docType.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import fileUploadNote from "@/views/common/fileUploadNote.vue";
export default {
  provide() {
        return {
            parentValidator: this.$validator,
        };
    },
    components: {
    docType,
    FileUpload,
    VuePerfectScrollbar,
    fileUploadNote
  },
  methods: {
    updateTagVal(val, inde){
      if(val == 'support_letter'){
        this.uploadScanedFilsList[inde]['efileDocTagIds'] = [2]
      }else if(val == 'itinerary'){
        this.uploadScanedFilsList[inde]['efileDocTagIds'] = [8]
      }else if(val == 'lca'){
        this.uploadScanedFilsList[inde]['efileDocTagIds'] = [1]
      }else{
        this.uploadScanedFilsList[inde]['efileDocTagIds'] = []
      }
      this.uploadScanedFilsList = _.cloneDeep(this.uploadScanedFilsList);
      this.$validator.reset()
    },
    updateData(docs){
      let documents = docs;
      _.forEach(documents, (dItem)=>{
        if(!this.checkProperty(dItem, 'category')){
          dItem['category'] = '';
        }
      }) 
      this.uploadScanedFilsList = _.cloneDeep(documents);
      // console.log(JSON.stringify(this.uploadScanedFilsList))

    },
    updateDocUserType(){
      if(this.docUserType == 'Beneficiary'){
        _.forEach(this.uploadScanedFilsList, (dIt)=>{
          dIt['category'] = ''
        })
        this.uploadScanedFilsList = _.cloneDeep(this.uploadScanedFilsList)
      }
      
    },
    remove(index ,docs){
      let item=docs[index]
      docs.splice(index ,1);
      this.removeFileFromS3(item)
    },
    upload(docs) {
      this.paralegalformerrors ='';
      if (docs.length > 0) {
        var self = this;

        let invaliedFiles =[];
        docs.forEach(function (doc) {
          if(
            (doc.mimetype == "application/pdf" || doc.type == "application/pdf") ||
            (
                doc.mimetype == "application/msword" ||  doc.type == "application/msword" ||
                doc.mimetype ==  "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
                doc.type ==  "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            )
                  
            ){}else{
              invaliedFiles.push(doc);
            }

        });
        if(invaliedFiles.length>0){
          self.fileModel =[];
          self.paralegalformerrors ="Upload Only Pdf/MS Word Files"
          self.showToster({ message: "Upload Only Pdf/MS Word Files ", isError: true });
          return false;
        }

       
        let count = 0;
        docs.forEach(function (doc) {
          let formData = new FormData();
          formData.append("files", doc.file);
          formData.append("secureType", "private");
          formData.append("getDetails", true);
          if(
            (doc.mimetype == "application/pdf" || doc.type == "application/pdf") ||
            (
                doc.mimetype == "application/msword" ||  doc.type == "application/msword" ||
                doc.mimetype ==  "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
                doc.type ==  "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            )
                  
            ){

              self.filesAreuploading = true;

          self.$store.dispatch("uploadS3File", formData).then((response) => {
            count = count + 1;
            if (response.data && response.data.result) {
              response.data.result.forEach((urlGenerated) => {
                urlGenerated['status'] =true; 
                let tempUrl = urlGenerated
                tempUrl = Object.assign(tempUrl, { uploadedBy: self.checkProperty(self.getUserData, 'userId'), uploadedByName: self.checkProperty(self.getUserData, 'name'), uploadedByRoleId: self.getUserRoleId, uploadedByRoleName: self.checkProperty(self.getUserData, 'loginRoleName') });
                self.uploadScanedFilsList.push(tempUrl);
                self.uploadScanedFilsList = _.cloneDeep(
                  self.uploadScanedFilsList
                );
                if (parseInt(count) >= docs.length) {
                  self.filesAreuploading = false;
                }
              });
              if (count >= docs.length) {
                self.filesAreuploading = false;
              }
            }
          });
        }else{
          self.showToster({ message: "Upload Only Pdf/MS Word Files ", isError: true });

        }
        });
      }
    },

    getscannedCopiesList() {
      this.formsAndLettersList = [];
      let finalList = [];
      let postData = {
        petitionId: this.petition._id,
        page: 1,
        perpage: 100000,
      };
      this.$store
        .dispatch("getList", {
          data: postData,
          path: "/petition/scanned-copies-list",
        })
        .then((response) => {
          if (_.has(response, "list")) {
            this.scannedCopiesList = response["list"];
          }
        });
    },
    checkuploadScnnedFiles() {
      let val = false;
      if (this.uploadScanedFilsList.length > 0) {
        _.forEach(this.uploadScanedFilsList, (item) => {
          if (
            !_.has(item, "name") ||
            item["name"] == "" ||
            item["name"].trim() == ""
          ) {
            val = true;
          }
        });
      } else {
        val = true;
      }
      return val;
    },
    submitForm() {
      this.paralegalformerrors = "";
      
      this.$validator.validateAll().then((result) => {
      if(!result){
         return false;
      }
      
        if (this.uploadScanedFilsList.length > 0) {
          let uploadPayload = {
            documents: this.uploadScanedFilsList,
            petitionId: this.petitionDetails._id,
            today: moment().format("YYYY-MM-DD"),
            "docUserType":"Petitioner"
          };
         if(this.ACTIVITYCODE=='RFE_RESPONSE_UPLOAD_DOCS'){
          //alert(JSON.stringify(uploadPayload))
          //uploadPayload = Object.assign(uploadPayload ,{"docUserType":'Beneficiary'})
         }
         else if(this.ACTIVITYCODE=='UPLOAD_BENEFICIARY_SCANNED_COPY'){

            uploadPayload = Object.assign(uploadPayload ,{"docUserType":'Beneficiary'})
          }else{
         
              if(([50].indexOf(this.getUserRoleId)>-1) || ([51].indexOf(this.getUserRoleId)>-1 && this.checkProperty(this.petitionDetails,'subType')==18 && this.checkProperty(this.petitionDetails,'sponsorDetails','accountSubType')=='Sponsor')){
                uploadPayload['docUserType'] = 'Petitioner';

              }else if([51].indexOf(this.getUserRoleId)>-1){
                uploadPayload['docUserType'] = 'Beneficiary';

              }else{
                uploadPayload['docUserType'] = this.docUserType;

              }
          }
          if([2,10].indexOf(this.checkProperty(this.petitionDetails, 'type' ))>-1 && !this.checkProperty(this.petitionDetails, 'petitionerId') ){
            //uploadPayload['docUserType'] = 'Beneficiary';
          }
          this.filesAreuploading = true
          this.$store
            .dispatch("uploadScannedCopies", uploadPayload)
            .then((response) => {
              this.filesAreuploading = false;
              this.showToster({ message: response.message, isError: false });
              this.uploadSignedPopup = false;
              this.checkuploadScnnedFiles = [];
              this.hideMe();
              this.$emit("updatepetition");

            })
            .catch((error) => {
              this.filesAreuploading = false;
              this.paralegalformerrors = error;
              //this.showToster({ message: error, isError: true });
            });
        } else {
          this.paralegalformerrors = "Documents are required";
        }
      });
    },
    hideMe() {
      this.$emit("hideMe");
    },
  },
  watch: {
    showPopup(val) {
      if (!val) this.$emit("hideMe");
    },
  },
  mounted() {
    this.popTitle= 'Upload Signed Documents';
    if(this.ACTIVITYCODE=='UPLOAD_SIGNED_DOCUMENTS' && this.petitionDetails["completedActivities"].indexOf("RFE_REQUEST_PETITIONER_SIGN")>-1){
      this.popTitle= 'RFE Upload Signed Documents';  
    }
    this.showPopup = true;
    if(this.ACTIVITYCODE=='UPLOAD_BENEFICIARY_SCANNED_COPY'){
      this.docUserType = 'Beneficiary';
      this.popTitle= 'Upload Beneficiary Signed Documents';
      if([51].indexOf(this.getUserRoleId)>-1){
        this.popTitle= 'Upload Signed Documents';
      }
    }
    if(this.ACTIVITYCODE=='RFE_RESPONSE_UPLOAD_DOCS'){
      this.popTitle= 'Response Documents';  
    }
    if([2,10].indexOf(this.checkProperty(this.petitionDetails, 'type' ))>-1 && !this.checkProperty(this.petitionDetails, 'petitionerId') ){
      this.docUserType = 'Beneficiary';
    }
    
    setTimeout(()=>{

    
    if([50].indexOf(this.getUserRoleId)>-1){
      this.docUserType = 'Petitioner';

    }else if([51].indexOf(this.getUserRoleId)>-1){
      this.docUserType = 'Beneficiary';
      let loginData = this.$store.state.loginUserData;
      if(([4].indexOf( this.checkProperty(this.petitionDetails, "type"))>-1 )  && this.checkProperty(this.petitionDetails ,'subTypeDetails' ,'id' )==18  ){
        if(this.checkProperty(loginData,'accountType') && this.checkProperty(loginData,'accountType')=='Individual' && 
        this.checkProperty(loginData,'accountSubType') && this.checkProperty(loginData,'accountSubType')=='Sponsor'){
          this.docUserType = 'Petitioner';
        }
      }

    }else if(!this.checkH4Required){
      this.docUserType = 'Petitioner';
    }else if(this.checkSignerLogin){
      this.docUserType = 'Petitioner';
    }

    if([2,10].indexOf(this.checkProperty(this.petitionDetails, 'type' ))>-1 && !this.checkProperty(this.petitionDetails, 'petitionerId') ){
      this.docUserType = 'Beneficiary';
    }
    this.showOptions =true;
  },100);

  
  },
  data: () => ({
    radioOptions: [
        { label: 'Forms', value: 'forms' },
        { label: 'Support Letter', value: 'support_letter' },
        { label: 'Itinerary', value: 'itinerary' },
        { label: 'LCA', value: 'lca' },
        { label: 'Others', value: 'Others' }
      ],
    documentCheckData:[
      {'name':'Forms', 'val':'Forms'},
      {'name':'Support', 'val':'Support'},
      {'name':'Iternary', 'val':'Iternary'},
      {'name':'Others', 'val':'Others'}
    ],
    formLetterType:'',
    showOptions:false,
    popTitle:'Upload Signed Documents',
    docUserType:'Beneficiary',
            fuploder: false,

    paralegalformerrors:'',
disabled_btn:false,
    fileModel: [],
    uploadScanedFilsList: [],
    filesAreuploading: false,
    loading: false,
    showPopup: false,
    comments: false,
    formerrors: {
      msg: "",
    },
  }),
  props: {
    ACTIVITYCODE: {
      type: String,
      default: null,
    },
    petitionDetails: {
      type: Object,
      default: null,
    },
    workFlowDetails:{
      type: Object,
      default: null,
    }

  },
  computed:{
    checkLcarequired(){
      let returnVal =false;
      let wf = _.cloneDeep(this.workFlowDetails);

      if (wf && _.has(wf, "config")) {
        let lcaRequired = _.find(wf["config"], { code: "LCA_REQUEST" });

        if (
          lcaRequired &&
          _.has(lcaRequired, "actionRequired") &&
           lcaRequired.actionRequired == "Yes"
        ) {
          
         
          returnVal =true;

        } 
      

    return returnVal;
      }

    },
    
    checkH4Required(){
      let h4Required = false;
       if(this.checkProperty(this.petitionDetails ,'beneficiaryInfo' ,'maritalStatus') !=1){
       
        if(this.checkProperty(this.petitionDetails['dependentsInfo'],'spouse' ,'h4Required') ==true){
          h4Required =true;
        }
        if(this.checkProperty( this.petitionDetails['dependentsInfo'] ,'childrens')){
               _.forEach(this.petitionDetails['dependentsInfo']['childrens'],(item)=>{
                   if(item.h4Required==true){
                    h4Required =true;
                   }
                })
        }
      
       }
       return h4Required;
    },
    checkSignerLogin(){
      let returnVal = false;
      let enableForSigner = false;
      let signersList =[];
      if(this.workFlowDetails && this.checkProperty(this.workFlowDetails, 'config')){
        if(this.getTenantTypeId ==2){
          let signersActiVityList = _.find(this.workFlowDetails.config , {"code":'RFE_DOC_SIGNER_LIST'});
          if(signersActiVityList && signersActiVityList.editors){
            signersList = _.map(signersActiVityList.editors, 'roleId');
          }
        }
        enableForSigner = signersList.indexOf(this.getUserRoleId) > -1;
        console.log()
        if(enableForSigner){
          returnVal = true;
        }
      }
      return returnVal;
    },
  }
};
</script>
